var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BlogItem',{directives:[{name:"viewer",rawName:"v-viewer"}],attrs:{"blogList":_vm.blogList}}),_vm._v(" "),_c('Pagination',{attrs:{"getBlogList":_vm.getBlogList,"totalPage":_vm.totalPage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33ddef50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/blog/BlogList.vue
// module id = null
// module chunks = 